import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {ConfigurationService} from '~/app/core/services/configuration.service';
import {ErrorService} from '~/app/core/services/error.service';
import {HierarchyA} from '@model/HierarchyA';
import {HierarchyB} from '@model/HierarchyB';
import {HierarchyC} from '@model/HierarchyC';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HierarchyTree} from '@model/HierarchyTree';
import {GoogleAnalyticsService} from "~/app/core/services/google-analytics.service";
import {BaseService} from "~/app/core/services/base.service";

const GET_HIERARCHY_LIST = '/hierarchy/list/'; // {hoId} /A , B , cC (GET)

const GET_STORES_COUNT = '/hierarchy/storescount/'; // {hoId}/{store_id} (GET)

const INSERT_LEVEL = '/hierarchy/level/'; // {hoId} (POST)
const UPDATE_LEVEL = '/hierarchy/level/'; // {hoId} (PUT)
const DELETE_LEVEL = '/hierarchy/level/'; // {hoId} (DEL)

const INSERT_STORE = '/hierarchy/store/'; // {hoId} (POST)
const UPDATE_STORE = '/hierarchy/store/'; // {hoId} (PUT)
const DELETE_STORE = '/hierarchy/store/'; // {hoId} (DEL)

const GET_TOP_HIERARCHY = '/hierarchy/top/';
const GET_BOTTOM_HIERARCHY = '/hierarchy/bottom/';

@Injectable({
  providedIn: 'root'
})
export class HierarchyService {

  public hoId: string = '';
  public userId: string = '';

  constructor(
    private configuration: ConfigurationService,
    private errorService: ErrorService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private baseService: BaseService) {
  }

  getHierarchyListA(hoId: string): Observable<HierarchyA[]> {
    console.warn(this.configuration.RESTURL + GET_HIERARCHY_LIST + hoId + '/A');
    return this.baseService.getHttpObject<any>(
      'getHierarchyListA',
      'hierarchy-service',
      this.configuration.RESTURL + GET_HIERARCHY_LIST + hoId + '/A')
      .pipe(map((data: any) => data));
  }

  getHierarchyListB(hoId: string): Observable<HierarchyB[]> {
    console.warn(this.configuration.RESTURL + GET_HIERARCHY_LIST + hoId + '/B');
    return this.baseService.getHttpObject<any>(
      'getHierarchyListB',
      'hierarchy-service',
      this.configuration.RESTURL + GET_HIERARCHY_LIST + hoId + '/B')
      .pipe(map((data: any) => data));
  }

  getHierarchyListC(hoId: string): Observable<HierarchyC[]> {
    console.warn(this.configuration.RESTURL + GET_HIERARCHY_LIST + hoId + '/C');
    return this.baseService.getHttpObject<any>(
      'getHierarchyListC',
      'hierarchy-service',
      this.configuration.RESTURL + GET_HIERARCHY_LIST + hoId + '/C')
      .pipe(map((data: any) => data));
  }

  getStoresCount(hoId: string, level: number): Observable<any> {
    console.warn(this.configuration.RESTURL + GET_STORES_COUNT + hoId + '/' + level);
    return this.baseService.getHttpObject<any>(
      'getStoresCount',
      'hierarchy-service',
      this.configuration.RESTURL + GET_STORES_COUNT + hoId + '/' + level)
      .pipe(map((data: any) => data));
  }

  getTopHierarchy(hoId: string): Observable<HierarchyTree[]> {
    console.warn(this.configuration.RESTURL + GET_TOP_HIERARCHY + hoId);
    return this.baseService.getHttpObject<any>(
      'getTopHierarchy',
      'hierarchy-service',
      this.configuration.RESTURL + GET_TOP_HIERARCHY + hoId)
      .pipe(map(resp => {
        let results: Array<any> = [];
        results.push(resp);
        return results;
      }));
  }

  getBottomHierarchy(hoId: string): Observable<HierarchyTree[]> {
    console.warn(this.configuration.RESTURL + GET_BOTTOM_HIERARCHY + hoId);
    return this.baseService.getHttpObject<any>(
      'getBottomHierarchy',
      'hierarchy-service',
      this.configuration.RESTURL + GET_BOTTOM_HIERARCHY + hoId)
      .pipe(map((data: any) => data));
  }

  // INSERT_LEVEL
  insertLevel(hoId: string, selectedLevel: number, levelUpdated: boolean, newTypeTextValue: string): Observable<any> {
    let hierarchyA = new HierarchyA();
    hierarchyA.hoId = +hoId;
    hierarchyA.level = selectedLevel;
    hierarchyA.levelUpdated = levelUpdated; // TODO figure out where to get this true/false value from
    hierarchyA.type = newTypeTextValue;

    console.warn('POST (INSERT) - /fs-online-invoicing-ws/rest/v1/hierarchy/level/' + hoId, hierarchyA);

    return this.baseService.postHttpObject<any>(
      'insertLevel',
      'hierarchy-service',
      this.configuration.RESTURL + INSERT_LEVEL + hoId,
      hierarchyA)
      .pipe(
        catchError(this.errorService.handleError<HierarchyA>('hierarchy.service insertLevel(' + hoId + ',' + JSON.stringify(hierarchyA) + ')', hierarchyA))
      );
  }

  // DELETE_LEVEL
  deleteLevel(hoId: string, selectedLevel: number, levelUpdated: boolean, newTypeTextValue: string): Observable<any> {

    let hierarchyA = new HierarchyA();
    hierarchyA.hoId = +hoId;
    hierarchyA.level = selectedLevel;
    hierarchyA.levelUpdated = levelUpdated; // TODO figure out where to get this true/false value from
    hierarchyA.type = newTypeTextValue;

    console.warn('DEL (DELETE) - /fs-online-invoicing-ws/rest/v1/hierarchy/level/' + hoId, hierarchyA);

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(hierarchyA)

    };
    return this.baseService.deleteHttpObject<any>(
      'deleteLevel',
      'hierarchy-service',
      this.configuration.RESTURL + DELETE_LEVEL + hoId, options)
      .pipe(
        catchError(this.errorService.handleError('hierarchy.service deleteLevel(' + hoId + ',' + JSON.stringify(hierarchyA) + ')', hierarchyA))
      );
  }


  // UPDATE_LEVEL
  updateLevel(hoId: string, selectedLevel: number, levelUpdated: boolean, newTypeTextValue: string): Observable<any> {

    let hierarchyA = new HierarchyA();
    hierarchyA.hoId = +hoId;
    hierarchyA.level = selectedLevel;
    hierarchyA.levelUpdated = levelUpdated; // TODO figure out where to get this true/false value from
    hierarchyA.type = newTypeTextValue;
    console.log('PUT (update) - /fs-online-invoicing-ws/rest/v1/hierarchy/level/' + hoId, hierarchyA);

    console.warn(this.configuration.RESTURL + UPDATE_LEVEL + hoId, hierarchyA);
    return this.baseService.putHttpObject<any>(
      'updateLevel',
      'hierarchy-service',
      this.configuration.RESTURL + UPDATE_LEVEL + hoId, hierarchyA)
      .pipe(
        catchError(this.errorService.handleError('hierarchy.service updateLevel(' + hoId + ',' + JSON.stringify(hierarchyA) + ')', hierarchyA))
      );
  }

  // INSERT_STORE
  insertStore(hoId: string, results) {
    console.log('POST (INSERT) - /fs-online-invoicing-ws/rest/v1/hierarchy/store/' + hoId);

    console.log('results: ', results);

    let hierarchyC = new HierarchyC();
    hierarchyC.chain = results.chain;
    hierarchyC.description = results.description;
    hierarchyC.hoId = +hoId;
    hierarchyC.key = results.name;
    hierarchyC.levelParent = results.parent.key;
    hierarchyC.level = results.type.level;
    hierarchyC.levelUpdated = results.parent.levelUpdated; // TODO figure out where to get this true/false value from
    hierarchyC.storeId = results.storeId;
    hierarchyC.type = results.type.type;

    console.warn('POST (INSERT) - /fs-online-invoicing-ws/rest/v1/hierarchy/store' + INSERT_STORE + hoId, hierarchyC);
    return this.baseService.postHttpObject<any>(
      'insertStore',
      'hierarchy-service',
      this.configuration.RESTURL + INSERT_STORE + hoId, hierarchyC)
      .pipe(
        catchError(this.errorService.handleError<HierarchyA>('hierarchy.service insertStore(' + hoId + ',' + JSON.stringify(hierarchyC) + ')', hierarchyC))
      );
  }

  deleteStore(hoId: string, results) {
    let hierarchyC = new HierarchyC();
    hierarchyC.chain = results.chain;
    hierarchyC.description = results.description;
    hierarchyC.hoId = +hoId;
    hierarchyC.key = results.name;
    hierarchyC.levelParent = results.parent.key;
    hierarchyC.level = results.type.level;
    hierarchyC.levelUpdated = results.parent.levelUpdated; // TODO figure out where to get this true/false value from
    hierarchyC.storeId = results.storeId;
    hierarchyC.type = results.type.type;

    console.warn('DEL (DELETE) - /fs-online-invoicing-ws/rest/v1/hierarchy/store' + DELETE_STORE + hoId, hierarchyC);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(hierarchyC)

    };
    return this.baseService.deleteHttpObject<any>(
      'deleteStore',
      'hierarchy-service',
      this.configuration.RESTURL + DELETE_STORE + hoId, options)
      .pipe(
        catchError(this.errorService.handleError('hierarchy.service deleteStore(' + hoId + ',' + JSON.stringify(hierarchyC) + ')', hierarchyC))
      );
  }

  updateStore(hoId: string, results) {
    console.log('results..:  ', results);
    let hierarchyC = new HierarchyC();
    hierarchyC.chain = results.chain;
    hierarchyC.description = results.description;
    hierarchyC.hoId = +hoId;
    hierarchyC.key = results.name;
    hierarchyC.levelParent = results.parent.key;
    hierarchyC.level = results.type.level;
    hierarchyC.levelUpdated = results.parent.levelUpdated; // TODO figure out where to get this true/false value from
    hierarchyC.storeId = results.storeId;
    hierarchyC.type = results.type.type;
    hierarchyC.oldKey = results.name;
    console.warn('PUT (update) - /fs-online-invoicing-ws/rest/v1/hierarchy/store' + UPDATE_STORE + hoId, hierarchyC);
    return this.baseService.putHttpObject<any>(
      'updateStore',
      'hierarchy-service',
      this.configuration.RESTURL + UPDATE_STORE + hoId, hierarchyC)
      .pipe(
        catchError(this.errorService.handleError('hierarchy.service updateStore(' + hoId + ',' + JSON.stringify(hierarchyC) + ')', hierarchyC))
      );
  }
}

